/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  MicrosoftAspNetCoreMvcProblemDetails,
  TrainWithMeModulesTrainingDtosRequestsPutStandingCallLinkRequest,
  TrainWithMeModulesTrainingDtosResponsesStandingCallLinkResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const deleteMeStandingCallLink = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesStandingCallLinkResponse>(
      {url: `/me/standing-call-link`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteMeStandingCallLinkMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMeStandingCallLink>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMeStandingCallLink>>, TError,void, TContext> => {

const mutationKey = ['deleteMeStandingCallLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMeStandingCallLink>>, void> = () => {


          return  deleteMeStandingCallLink(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMeStandingCallLinkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMeStandingCallLink>>>

    export type DeleteMeStandingCallLinkMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const useDeleteMeStandingCallLink = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMeStandingCallLink>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMeStandingCallLink>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteMeStandingCallLinkMutationOptions(options), queryClient);
    }
    export const getMeStandingCallLink = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesStandingCallLinkResponse>(
      {url: `/me/standing-call-link`, method: 'GET', signal
    },
      options);
    }




export const getGetMeStandingCallLinkQueryKey = () => {
    return [
    `/me/standing-call-link`
    ] as const;
    }


export const getGetMeStandingCallLinkQueryOptions = <TData = Awaited<ReturnType<typeof getMeStandingCallLink>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeStandingCallLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeStandingCallLinkQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeStandingCallLink>>> = ({ signal }) => getMeStandingCallLink(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeStandingCallLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeStandingCallLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getMeStandingCallLink>>>
export type GetMeStandingCallLinkQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetMeStandingCallLink<TData = Awaited<ReturnType<typeof getMeStandingCallLink>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeStandingCallLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeStandingCallLink>>,
          TError,
          Awaited<ReturnType<typeof getMeStandingCallLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeStandingCallLink<TData = Awaited<ReturnType<typeof getMeStandingCallLink>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeStandingCallLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeStandingCallLink>>,
          TError,
          Awaited<ReturnType<typeof getMeStandingCallLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMeStandingCallLink<TData = Awaited<ReturnType<typeof getMeStandingCallLink>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeStandingCallLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMeStandingCallLink<TData = Awaited<ReturnType<typeof getMeStandingCallLink>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeStandingCallLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeStandingCallLinkQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putMeStandingCallLink = (
    trainWithMeModulesTrainingDtosRequestsPutStandingCallLinkRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsPutStandingCallLinkRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesStandingCallLinkResponse>(
      {url: `/me/standing-call-link`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsPutStandingCallLinkRequest, signal
    },
      options);
    }




export const getPutMeStandingCallLinkMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMeStandingCallLink>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPutStandingCallLinkRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putMeStandingCallLink>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPutStandingCallLinkRequest>}, TContext> => {

const mutationKey = ['putMeStandingCallLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMeStandingCallLink>>, {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPutStandingCallLinkRequest>}> = (props) => {
          const {data} = props ?? {};

          return  putMeStandingCallLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutMeStandingCallLinkMutationResult = NonNullable<Awaited<ReturnType<typeof putMeStandingCallLink>>>
    export type PutMeStandingCallLinkMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsPutStandingCallLinkRequest> | undefined
    export type PutMeStandingCallLinkMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePutMeStandingCallLink = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMeStandingCallLink>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPutStandingCallLinkRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMeStandingCallLink>>,
        TError,
        {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPutStandingCallLinkRequest>},
        TContext
      > => {
      return useMutation(getPutMeStandingCallLinkMutationOptions(options), queryClient);
    }
